import { Plus, Plane, HeartPulse, FileOutput, Upload, ListTodo, MessageSquare, Stethoscope } from "lucide-react";

const ACTIONS = [
  { id: "new-case", label: "All Cases", icon: Plus, nav: { action: "cases" } },
  { id: "dispatch-drone", label: "Dispatch Drone", icon: Plane, nav: { view: "drone" } },
  { id: "request-rn", label: "Request RN", icon: Stethoscope, nav: { view: "telehealth" } },
  { id: "schedule-telehealth", label: "Telehealth", icon: HeartPulse, nav: { action: "telehealth" } },
  { id: "generate-demand", label: "Generate Demand", icon: FileOutput, nav: { view: "litigation" } },
  { id: "upload-evidence", label: "Evidence", icon: Upload, nav: { action: "cases" } },
  { id: "create-task", label: "Create Task", icon: ListTodo, nav: { view: "litigation" } },
  { id: "message-client", label: "Message Client", icon: MessageSquare, nav: { action: "cases" } },
];

export const QuickActions = ({ onNavigate }) => (
  <div className="fixed right-3 top-1/2 -translate-y-1/2 z-[70] hidden xl:flex flex-col gap-1.5" data-testid="quick-actions">
    {ACTIONS.map((a) => (
      <button key={a.id} onClick={() => onNavigate(a.nav)} data-testid={`qa-${a.id}`} title={a.label}
        className="group relative h-10 w-10 rounded-2xl bg-[#0E1624] border border-[#1E2C45] flex items-center justify-center text-slate-400 hover:text-blue-400 hover:border-blue-500/40 hover:shadow-[0_0_15px_rgba(59,130,246,0.25)] transition-all">
        <a.icon className="w-4 h-4" />
        <span className="absolute right-12 px-2 py-1 rounded-lg bg-[#152033] border border-[#1E2C45] text-[10px] text-slate-300 whitespace-nowrap opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity">{a.label}</span>
      </button>
    ))}
  </div>
);

export default QuickActions;
